import { Injectable } from '@odinjs/odin';
import { FieldAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { ISO_DATE_FORMAT } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils';
import Moment from 'moment';
import { getFoundationDataContext } from '../app/bootstrap-foundation';
import { YES } from '../constants/application-constants';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { FieldValidatorsName } from '../constants/validators-name-constant';
import { CustomMessageRuleParameters, HealthInsuranceCardProps, PseudonymCustomMenssage, VisibilityFieldsResponse } from '../controllers/pseudonym-appointments/pseudonym-interfaces';
import { DatePickerData, DatePickerEventsData } from '../interfaces/date-picker';
import { CUSTOM_MESSAGE_TYPE } from '../constants/custom-message-type';
import { closeToastNotification, DEFAULT_TIMEOUT, showToastNotificationSuccess } from '../utils/toast-notification-utils';
import { ScheduleType } from '../constants/schedule-type';

@Injectable({})
export default class AppointmentService {
  static getCountAppointmentsInPeriod(patientId: string, startDate: string, endDate: string): Promise<DatePickerData[]> {
    return HttpService.get(APPLICATION_ENDPOINTS.APPOINTMENT_PERIOD_COUNT, {
      endDate,
      patientId,
      startDate,
    }).then( response => {
      const body = response.body as [];
      return body.map((datePickerData: DatePickerData) => {
        const event: DatePickerEventsData = {
          id: datePickerData.date,
          status: 'confirmed',
          title: datePickerData.date
        };

        datePickerData.date = Moment(datePickerData.date, ISO_DATE_FORMAT).toJSON();
        datePickerData.events = [ event ];
        return datePickerData;
      });
    });
  }

  static confirmAndRequestAppointments(scheduleSequence: number, patientId: number, confirmAppointmentInfoList: Record<string, Value>[]): Promise<Record<string, Value>> {
    let request = APPLICATION_ENDPOINTS.SCHEDULE_CONFIRM;
    let requestParameter = {};

    if (ScheduleType.CHECKUP === confirmAppointmentInfoList[0]?.ieTipoAgendamento) {
      request = APPLICATION_ENDPOINTS.CHECKUP_CONFIRM;
      requestParameter = { checkupSequence: scheduleSequence, patientId };
    } else {
      requestParameter = { nrSeqAgeint: scheduleSequence, patientId };
    }

    const bodyParameters = { body: confirmAppointmentInfoList as unknown as Record<string, Value> }

    return HttpService.post(request, requestParameter, bodyParameters).then(response => {
      return response.body as Record<string, Value>;
    });
  }

  static getAppointmentFieldLocation(locationField: FieldAPI): Promise<boolean> {
    const required = {
      'name': FieldValidatorsName.REQUIRED,
      'options': {}
    };
    return HttpService.get(APPLICATION_ENDPOINTS.GET_VISIBILITY_OF_FIELDS).then(response => {
      const body = response.body as VisibilityFieldsResponse;
      const isLocationRequired = YES === body?.locationRequired;
      if (isLocationRequired) {
        locationField.addValidator(required);
      } else {
        locationField.removeValidator(FieldValidatorsName.REQUIRED);
      }
      return isLocationRequired;
    });
  }

  static messageOnInsuranceSelection(selectedValue: HealthInsuranceCardProps): void {
    const body = {
      action: CUSTOM_MESSAGE_TYPE.INSURANCE_SELECTION,
      insuranceCode: selectedValue?.healthInsuranceId
    } as CustomMessageRuleParameters;
    const applicationContext = getFoundationDataContext();
    let messageToastID = applicationContext.get('messageToastID') as string;
    closeToastNotification(messageToastID);

    HttpService.get(APPLICATION_ENDPOINTS.GET_WSUITE_CUSTOM_MESSAGE, { ...body }).then(response => {
      const pseudonymCustomMenssage = response.body as PseudonymCustomMenssage;
      if (pseudonymCustomMenssage?.message) {
        messageToastID = showToastNotificationSuccess(pseudonymCustomMenssage.message, DEFAULT_TIMEOUT.NONE);
        applicationContext.set({ messageToastID });
      }
    });
  }

}
